"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var loader_1 = require("../../libs/voicefocus/loader");

var support_1 = require("../../libs/voicefocus/support");

var DefaultBrowserBehavior_1 = require("../browserbehavior/DefaultBrowserBehavior");

var ConsoleLogger_1 = require("../logger/ConsoleLogger");

var LogLevel_1 = require("../logger/LogLevel");

var Versioning_1 = require("../versioning/Versioning");

var NoOpVideoFrameProcessor_1 = require("../videoframeprocessor/NoOpVideoFrameProcessor");

var BackgroundBlurProcessorBuiltIn_1 = require("./BackgroundBlurProcessorBuiltIn");

var BackgroundBlurProcessorProvided_1 = require("./BackgroundBlurProcessorProvided");

var BackgroundBlurStrength_1 = require("./BackgroundBlurStrength");

var ModelSpecBuilder_1 = require("./ModelSpecBuilder");
/** @internal */


var CREATE_DEFAULT_MODEL_SPEC = function CREATE_DEFAULT_MODEL_SPEC() {
  return ModelSpecBuilder_1.default.builder().withSelfieSegmentationDefaults().build();
};
/** @internal */


var DEFAULT_CDN = 'https://static.sdkassets.chime.aws';
/** @internal */

var DEFAULT_PATHS = {
  worker: "".concat(DEFAULT_CDN, "/bgblur/workers/worker.js"),
  wasm: "".concat(DEFAULT_CDN, "/bgblur/wasm/_cwt-wasm.wasm"),
  simd: "".concat(DEFAULT_CDN, "/bgblur/wasm/_cwt-wasm-simd.wasm")
};
/**
 * No-op implementation of the blur processor. An instance of this class will be returned when a user attempts
 * to create a blur processor when it is not supported.
 */

/** @internal */

var NoOpBackgroundBlurProcessor = /*#__PURE__*/function (_NoOpVideoFrameProces) {
  _inherits(NoOpBackgroundBlurProcessor, _NoOpVideoFrameProces);

  var _super = _createSuper(NoOpBackgroundBlurProcessor);

  function NoOpBackgroundBlurProcessor() {
    _classCallCheck(this, NoOpBackgroundBlurProcessor);

    return _super.apply(this, arguments);
  }

  _createClass(NoOpBackgroundBlurProcessor, [{
    key: "setBlurStrength",
    value:
    /**
     * no-op
     */
    function setBlurStrength() {}
    /**
     * no-op
     * @returns
     */

  }, {
    key: "loadAssets",
    value: function loadAssets() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return");

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
    /**
     * no-op
     */

  }, {
    key: "addObserver",
    value: function addObserver() {}
    /**
     * no-op
     */

  }, {
    key: "removeObserver",
    value: function removeObserver() {}
  }]);

  return NoOpBackgroundBlurProcessor;
}(NoOpVideoFrameProcessor_1.default);
/**
 * [[BackgroundBlurVideoFrameProcessor]]
 * Creates a background blur processor which identifies the foreground person and blurs the background.
 */


var BackgroundBlurVideoFrameProcessor = /*#__PURE__*/function () {
  function BackgroundBlurVideoFrameProcessor() {
    _classCallCheck(this, BackgroundBlurVideoFrameProcessor);
  }

  _createClass(BackgroundBlurVideoFrameProcessor, null, [{
    key: "create",
    value:
    /**
     * A factory method that will call the private constructor to instantiate the processor and asynchronously
     * initialize the worker, wasm, and ML models. Upon completion of the initialization the promise will either
     * be resolved or rejected.
     * @param spec The spec defines the assets that will be used for adding background blur to a frame
     * @param blurStrength How much blur to apply to a frame
     * @returns
     */
    function create(spec, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _options, logger, supported, processor;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                spec = BackgroundBlurVideoFrameProcessor.resolveSpec(spec);
                options = BackgroundBlurVideoFrameProcessor.resolveOptions(options);
                _options = options, logger = _options.logger;
                _context2.next = 5;
                return BackgroundBlurVideoFrameProcessor.isSupported(spec, options);

              case 5:
                supported = _context2.sent;
                // if blur is not supported do not initialize. The processor will become a no op if not supported.
                logger.info("processor is ".concat(supported ? '' : 'not', " supported"));

                if (supported) {
                  _context2.next = 10;
                  break;
                }

                logger.warn('Using no-op processor because background blur is not supported');
                return _context2.abrupt("return", new NoOpBackgroundBlurProcessor());

              case 10:
                _context2.next = 12;
                return BackgroundBlurProcessorProvided_1.default.isSupported();

              case 12:
                if (!_context2.sent) {
                  _context2.next = 17;
                  break;
                }

                logger.info('Using browser-provided background blur');
                processor = new BackgroundBlurProcessorProvided_1.default(spec, options);
                _context2.next = 19;
                break;

              case 17:
                logger.info('Using built-in background blur');
                processor = new BackgroundBlurProcessorBuiltIn_1.default(spec, options);

              case 19:
                _context2.next = 21;
                return processor.loadAssets();

              case 21:
                return _context2.abrupt("return", processor);

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
    /**
     * Based on the SDK version, return an asset group.
     *
     * @returns the default asset spec, based on the SDK version.
     */

  }, {
    key: "defaultAssetSpec",
    value: function defaultAssetSpec() {
      var version = Versioning_1.default.sdkVersionSemVer;
      return {
        assetGroup: "sdk-".concat(version.major, ".").concat(version.minor)
      };
    }
    /**
     * Set the given parameters to the url. Existing parameters in the url are preserved.
     * If duplicate parameters exist, they are overwritten, so it's safe to call this method multiple
     * times on the same url.
     *
     * @param url the initial url, can include query parameters
     * @param queryParams the query parameters to set
     * @returns a new url with the given query parameters.
     */

  }, {
    key: "createUrlWithParams",
    value: function createUrlWithParams(url, queryParams) {
      var u = new URL(url);
      var keys = Object.keys(queryParams);

      for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
        var key = _keys[_i];

        if (queryParams[key] !== undefined) {
          u.searchParams.set(key, queryParams[key]);
        }
      }

      return u.toString();
    }
    /**
     * Based on the spec that is passed in set defaults for spec
     * @param spec the spec that was passed in
     * @returns An updated spec with defaults set
     */

  }, {
    key: "resolveSpec",
    value: function resolveSpec(spec) {
      var _ref = spec || {},
          _ref$paths = _ref.paths,
          paths = _ref$paths === void 0 ? DEFAULT_PATHS : _ref$paths,
          _ref$model = _ref.model,
          model = _ref$model === void 0 ? CREATE_DEFAULT_MODEL_SPEC() : _ref$model,
          _ref$assetGroup = _ref.assetGroup,
          assetGroup = _ref$assetGroup === void 0 ? this.defaultAssetSpec().assetGroup : _ref$assetGroup,
          _ref$revisionID = _ref.revisionID,
          revisionID = _ref$revisionID === void 0 ? this.defaultAssetSpec().revisionID : _ref$revisionID;

      var params = {
        assetGroup: assetGroup,
        revisionID: revisionID,
        sdk: encodeURIComponent(Versioning_1.default.sdkVersion),
        ua: encodeURIComponent(Versioning_1.default.sdkUserAgentLowResolution)
      };
      paths.worker = this.createUrlWithParams(paths.worker, params);
      paths.wasm = this.createUrlWithParams(paths.wasm, params);
      paths.simd = this.createUrlWithParams(paths.simd, params);
      model.path = this.createUrlWithParams(model.path, params);
      return {
        paths: paths,
        model: model,
        assetGroup: assetGroup,
        revisionID: revisionID
      };
    }
    /**
     * Based on the options that are passed in set defaults for options
     * @param options  the options that are passed in
     * @returns An updated set of options with defaults set
     */

  }, {
    key: "resolveOptions",
    value: function resolveOptions(options) {
      options = options !== null && options !== void 0 ? options : {};

      if (!options.blurStrength) {
        options.blurStrength = BackgroundBlurStrength_1.default.MEDIUM;
      }

      if (!options.logger) {
        options.logger = new ConsoleLogger_1.default('BackgroundBlurProcessor', LogLevel_1.default.INFO);
      }

      if (!options.reportingPeriodMillis) {
        options.reportingPeriodMillis = 1000;
      }

      var DEFAULT_FILTER_CPU_UTILIZATION = 30;

      if (!options.filterCPUUtilization) {
        options.filterCPUUtilization = DEFAULT_FILTER_CPU_UTILIZATION;
      } else if (options.filterCPUUtilization < 0 || options.filterCPUUtilization > 100) {
        options.logger.warn('filterCPUUtilization must be set to a range between 0 and 100 percent. Falling back to default of 40 percent');
        options.filterCPUUtilization = DEFAULT_FILTER_CPU_UTILIZATION;
      }

      return options;
    }
    /**
     * This method will detect the environment in which it is being used and determine if background
     * blur can be used.
     * @param spec The {@link BackgroundBlurSpec} spec that will be used to initialize asssets
     * @param options options such as logger
     * @returns a boolean promise that will resolve to true if supported and false if not
     */

  }, {
    key: "isSupported",
    value: function isSupported(spec, options) {
      spec = BackgroundBlurVideoFrameProcessor.resolveSpec(spec);
      options = BackgroundBlurVideoFrameProcessor.resolveOptions(options);
      var _options2 = options,
          logger = _options2.logger; // could not figure out how to remove globalThis to test failure case

      /* istanbul ignore next */

      if (typeof globalThis === 'undefined') {
        logger.info('Browser does not have globalThis.');
        return Promise.resolve(false);
      }

      var browser = new DefaultBrowserBehavior_1.default();

      if (!browser.supportsBackgroundFilter()) {
        logger.info('Browser is not supported.');
        return Promise.resolve(false);
      }

      if (!support_1.supportsWASM(globalThis, logger)) {
        logger.info('Browser does not support WASM.');
        return Promise.resolve(false);
      }

      return this.supportsBackgroundBlur(globalThis, spec, logger);
    }
  }, {
    key: "supportsBackgroundBlur",
    value: function supportsBackgroundBlur() {
      var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : globalThis;
      var spec = arguments.length > 1 ? arguments[1] : undefined;
      var logger = arguments.length > 2 ? arguments[2] : undefined;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var workerURL, worker;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (support_1.supportsWorker(scope, logger)) {
                  _context3.next = 3;
                  break;
                }

                logger.info('Browser does not support web workers.');
                return _context3.abrupt("return", false);

              case 3:
                // Use the actual worker path -- it's only 20KB, and it'll get the cache warm.
                workerURL = spec.paths.worker;
                _context3.prev = 4;
                _context3.next = 7;
                return loader_1.loadWorker(workerURL, 'BackgroundBlurWorker', {}, null);

              case 7:
                worker = _context3.sent;

                try {
                  worker.terminate();
                } catch (e) {
                  logger.info("Failed to terminate worker. ".concat(e.message));
                }

                return _context3.abrupt("return", true);

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3["catch"](4);
                logger.info("Failed to fetch and instantiate test worker ".concat(_context3.t0.message));
                return _context3.abrupt("return", false);

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[4, 12]]);
      }));
    }
  }]);

  return BackgroundBlurVideoFrameProcessor;
}();

exports.default = BackgroundBlurVideoFrameProcessor;